//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Service',
  props: ['serviceUrl'],
  methods: {
    openLink() {
      window.location.href = this.serviceUrl;
    }
  },
  watch: {
    serviceUrl: function(newVal){
      this.serviceUrl = newVal
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ManualCustomerService.vue